import { render } from "./SchedulesDrawerForm.vue?vue&type=template&id=71027d38&scoped=true"
import script from "./SchedulesDrawerForm.vue?vue&type=script&lang=js"
export * from "./SchedulesDrawerForm.vue?vue&type=script&lang=js"

import "./SchedulesDrawerForm.vue?vue&type=style&index=0&id=71027d38&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71027d38"]])

export default __exports__
import QDrawer from 'quasar/src/components/drawer/QDrawer.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDrawer,QField});
